module.exports = __webpack_public_path__ + "static/media/ey-logo.4dc02a09.png";